import {
  getBenestreamMenuItems,
  getBenestreamSettingsMenuItems,
  getDefaultMenuItems,
} from '../constants/routes.constants'
import {
  BenestreamMenuConfig,
  DefaultMenuConfig,
  Platform,
} from '../types/routing.types'

export const getFilteredMenuItems = (
  platform: Platform,
  userPolicies: string[],
): DefaultMenuConfig[] | BenestreamMenuConfig[] => {
  const menuItems =
    platform === 'default' ? getDefaultMenuItems() : getBenestreamMenuItems()

  return menuItems.filter((item) => {
    if (!item.policy) return true
    return userPolicies.includes(item.policy)
  })
}

export const getFilteredSettingsMenuItems = (
  userPolicies: string[],
): BenestreamMenuConfig[] => {
  const menuItems = getBenestreamSettingsMenuItems()

  return menuItems.filter((item) => {
    if (!item.policy) return true
    return userPolicies.includes(item.policy)
  })
}

export const getAllBenestreamMenuItems = (
  userPolicies: string[],
): BenestreamMenuConfig[] => {
  const regularItems = getFilteredMenuItems(
    'benestream',
    userPolicies,
  ) as BenestreamMenuConfig[]
  const settingsItems = getFilteredSettingsMenuItems(userPolicies)

  return [...regularItems, ...settingsItems]
}

export const shouldShowMenuItem = (
  menuItem: DefaultMenuConfig | BenestreamMenuConfig,
  userPolicies: string[],
): boolean => {
  if (!menuItem.policy) return true
  return userPolicies.includes(menuItem.policy)
}
